module.exports = __webpack_public_path__ + "img/full5-min.d0d40f2c.png";